export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900">
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/6b5420e493f9bf51e0ee8e5dc840dbb7.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      
      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <div className="mb-8">
                <div className="flex items-center gap-4 mb-6">
                  <img 
                    src="https://static.readdy.ai/image/97c320206ed08475f986f4f05d477848/5a6a5480219dadc71ff06553c0ed212f.webp" 
                    alt="Lino García Abogados - Especialistas en Extranjería" 
                    className="w-24 h-24"
                  />
                  <div>
                    <h2 className="text-2xl font-bold text-white">Abogado Lino García</h2>
                    <p className="text-lg text-yellow-300 font-semibold">Especialista en Migración y Extranjería</p>
                  </div>
                </div>
                <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                  "Vive y Trabaja en España Legalmente: <span className="text-yellow-300">Visado Nómada Digital en 20 Días</span>"
                </h1>
                <p className="text-xl lg:text-2xl mb-8 text-blue-100 leading-relaxed">
                  Obtén tu residencia legal en España para trabajar en remoto. <strong>Sin errores. Sin rechazos. Sin estrés.</strong>
                </p>
                <p className="text-lg mb-8 text-blue-50">
                  ⭐ El visado que está transformando la vida de miles de nómadas digitales
                </p>
              </div>

              {/* Nueva imagen de profesionales trabajando en España */}
              <div className="mb-8 rounded-2xl overflow-hidden shadow-2xl relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20coworking%20space%20in%20Barcelona%20with%20Spanish%20flag%20on%20wall%20decoration%2C%20young%20professionals%20working%20on%20laptops%20at%20shared%20desks%2C%20large%20window%20showing%20iconic%20Sagrada%20Familia%20cathedral%20Barcelona%20landmark%20in%20background%2C%20bright%20natural%20lighting%2C%20contemporary%20office%20interior%20design%2C%20productive%20atmosphere%2C%20professional%20photography%2C%20Mediterranean%20style%20workspace&width=800&height=500&seq=hero-professionals-sagrada-002&orientation=landscape"
                  alt="Profesionales trabajando en coworking Barcelona con vista a Sagrada Familia"
                  className="w-full h-auto object-cover"
                />
              </div>

              <div className="flex flex-wrap gap-4">
                <a 
                  href="#consulta" 
                  className="bg-white text-blue-700 px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
                >
                  ¿Calificas para el visado?
                </a>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <div className="text-center mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-4">
                  <i className="ri-calendar-check-line text-4xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Consulta Online Personalizada
                </h3>
                <p className="text-gray-600 mb-6">
                  Evaluación completa de tu elegibilidad + estrategia personalizada para tu caso
                </p>
              </div>

              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <div>
                    <p className="text-gray-800 font-semibold">Análisis de elegibilidad</p>
                    <p className="text-sm text-gray-600">Revisión completa de tu situación</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <div>
                    <p className="text-gray-800 font-semibold">Estrategia personalizada</p>
                    <p className="text-sm text-gray-600">Plan específico para tu caso</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <div>
                    <p className="text-gray-800 font-semibold">Checklist de documentos</p>
                    <p className="text-sm text-gray-600">Lista exacta de lo que necesitas</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <div>
                    <p className="text-gray-800 font-semibold">Sesión Zoom 45-60 min</p>
                    <p className="text-sm text-gray-600">Consulta en vivo con experto</p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-4 mb-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600">Desde</p>
                    <p className="text-3xl font-bold text-blue-600">80 USD</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-600">Respuesta en</p>
                    <p className="text-2xl font-bold text-gray-900">24h</p>
                  </div>
                </div>
              </div>

              <a 
                href="#consulta"
                className="block w-full bg-blue-600 text-white py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-all text-center shadow-lg whitespace-nowrap cursor-pointer"
              >
                Reservar Consulta Ahora
              </a>

              <p className="text-xs text-gray-500 mt-4 text-center">
                ✓ Respuesta garantizada en 24h | ✓ Sin compromiso | ✓ 100% online
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
